enum LeadNotesQueryTypeEnum {
  Personal = 'Personal',
  Seller = 'Seller',
}

export default LeadNotesQueryTypeEnum;
